import { FC } from "react";
import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";
import "./RecentOrderModal.css";

type Props = {
  open: boolean;
  orderId: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const RecentOrderModal: FC<Props> = ({
  open,
  orderId,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="RecentOrderModal">
      <div className="RecentOrderModal__backdrop" onClick={onCancel} />
      <div className="RecentOrderModal__content">
        <div className="RecentOrderModal__header">
          <Icon name="infoIcon" width={24} />
          <h3>Ordre under behandling</h3>
        </div>
        <div className="RecentOrderModal__body">
          <p>
            Du har en ordre (ID: {orderId}) som blev afsendt for nylig og
            afventer bekræftelse.
          </p>
          <p>
            Hvis du fortsætter med at bestille nu, kan det resultere i
            dobbeltbestillinger.
          </p>
          <p>
            <strong>Anbefaling:</strong> Kontakt salg først på telefon 4466 6800
          </p>
        </div>
        <div className="RecentOrderModal__actions">
          <Button buttonStyle="secondary" click={onCancel}>
            Annuller
          </Button>
          <Button buttonStyle="primary" click={onConfirm}>
            Bestil alligevel
          </Button>
        </div>
      </div>
    </div>
  );
};